import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AlertType } from 'src/app/core/enums/enums';
import { Passenger, PnrInfo } from 'src/app/core/models/itinerary.model';
import { StepMiniState } from 'src/app/core/models/models';
import { IReRouteQuoteRequest } from 'src/app/core/models/re-route.model';
import { ReRouteService } from 'src/app/re-route/services/re-route.service';
import { RemarksService } from 'src/app/search-result/services/remarks.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import {
  splitStep,
  aditionalInformationStep
} from 'src/app/re-route/store/reducers/re-route-modal-steps';

@Component({
  selector: 'app-re-route-main-container',
  templateUrl: './re-route-main-container.component.html',
  styleUrls: ['./re-route-main-container.component.scss']
})
export class ReRouteMainContainerComponent implements OnChanges {
  @Input() pnrInfo: PnrInfo;
  @Input() selectedPassengers: Passenger[];
  @Input() isError: boolean;
  @Input() splitIsNecesary: boolean;
  @Input() reRouteQuoteRequest: IReRouteQuoteRequest;

  @Output() backButton = new EventEmitter<boolean>();

  stepState$: Observable<StepMiniState>;
  alertType = AlertType;
  _error$;

  showModalRemarks: boolean = false;
  isAirline$: Observable<boolean>;
  public pnrInfo$: Observable<PnrInfo>;

  constructor(
    private reRouteService: ReRouteService,
    private settingsService: SettingsService,
    private remarksService: RemarksService,
    private itineraryService: ItineraryService
  ) {
    this.stepState$ = this.reRouteService.getStepsState();
  }

  ngOnInit() {
    this.isAirline$ = this.settingsService.getClientIsAirline();
    this.pnrInfo$ = this.itineraryService.getPnrInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.splitIsNecesary && changes.splitIsNecesary.currentValue) {
        this.reRouteService.dispatchSaveStepState(splitStep);
      }
    }
  }

  callAditionalInfoStep() {
    this.reRouteService.dispatchSaveStepState(aditionalInformationStep);
  }

  submit() {
    this.reRouteService.getDocsaDocs().subscribe((docs) => {
      this.reRouteQuoteRequest.docsa = docs;
    });
    this.reRouteService.dispatchReRouteQuoteRequest(this.reRouteQuoteRequest);
    this._error$ = this.reRouteService.getIsError();
    this.reRouteService.getPnrInfo().subscribe((pnrInfo) => {
      if (pnrInfo) {
        this.itineraryService.dispatchUpdatePnrInfo(pnrInfo);
      }
    });
  }

  backItinerary() {
    this.backButton.emit(true);
  }

  backItineraryRemark() {
    this.settingsService.getClientSettings().subscribe((settings) => {
      if (settings.requestFinalRemark) {
        this.remarksService
          .getRemarks()
          .pipe(take(1))
          .subscribe((remark) => {
            if (remark) {
              this.backButton.emit(true);
            } else {
              this.showModalRemarks = true;
            }
          });
      } else {
        this.backButton.emit(true);
      }
    });
  }
}
